module.exports = __webpack_public_path__ + "static/img/default.6b08a018.png";